var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentalCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M14.735 11.394l-.003-7.21c0-2.26-1.866-4.217-4.144-4.184-.441.006-.865.082-1.261.217-1.263.43-2.658.431-3.92.001C5.008.082 4.584.006 4.141 0 1.863-.032-.001 1.926 0 4.187l.003 7.21 6.563-.003v.003l8.169-.003z",
    transform: "translate(.12 .789)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.801 3.612c0 .647-.528 1.17-1.18 1.17-.651 0-1.18-.523-1.18-1.17 0-.646.529-1.17 1.18-1.17.652 0 1.18.524 1.18 1.17",
    transform: "translate(.12 .789)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M9.191 11.397H.003l2.372 10.978c.216.66.835 1.106 1.534 1.106h.054c.824 0 1.515-.615 1.604-1.426l1.867-5.985c.052-.466.728-.486.806-.023l2.238 6.098c.13.772.803 1.336 1.59 1.336.764 0 1.422-.53 1.58-1.269l1.086-10.815H9.191z",
    transform: "translate(.12 .789)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalCare);
export default __webpack_public_path__ + "static/media/dental_care.517387f3545ac616f16e05eff3d4d10d.svg";
export { ForwardRef as ReactComponent };